import { Divider } from '@eventbrite/eds-divider';
import { gettext } from '@eventbrite/i18n';
import {
    MagnifyingGlassIcon,
    MapPinIcon,
    Typography,
} from '@eventbrite/marmalade';
import {
    LocationProvider,
    useLocationContext,
} from '@eventbrite/search-takeover';
import { logEvent } from '@eventbrite/statsig';
import loadable from '@loadable/component';
import React, { useState } from 'react';
import { STATSIG_SEARCH_BAR_CLICK } from '../../../../constants';
import { useGlobalNavContext } from '../../../../state';
import { useGetSearchBarVariant } from '../../../../utils';
import {
    getHeapDataAttribute,
    HeapAttributes,
} from '../../../../utils/heap-data';
import './SearchBar.module.scss';
import styles from './SearchBar.module.scss';

const LazySearchTakeover = loadable.lib(
    () => import('@eventbrite/search-takeover'),
);

/**TODO: Search Page Hierarchy experiment cleanup EB-228109: if this experiment is successful,
 * we should elevate SearchTakeoverRenderer to a single location to avoid multiple re-renders
 *  **/
//TODO: start Hierarchy experiment cleanup EB-228109.
export const ResultsPageSearchBarContent = () => {
    const { location, isUsingUserLocation } = useLocationContext();
    const { Teams, Features, Components, Actions } = HeapAttributes;
    const currentLocationString = 'Current location';
    const { searchBar } = useGlobalNavContext();

    const [showSearch, setShowSearch] = useState(false);

    const handleClick = () => {
        logEvent(STATSIG_SEARCH_BAR_CLICK);
        setShowSearch(true);
    };
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            logEvent(STATSIG_SEARCH_BAR_CLICK);
            setShowSearch(true);
        }
    };
    function handleClose() {
        setShowSearch(false);
    }
    const isSearchBarExperiment = useGetSearchBarVariant();

    return (
        <div>
            {searchBar?.renderSearchBar && isSearchBarExperiment ? (
                <div
                    className={styles.main}
                    data-testid="header-search"
                    onClick={handleClick}
                    onKeyDown={handleKeyDown}
                    aria-label={gettext('open search bar').toString()}
                    data-heap-id={getHeapDataAttribute({
                        team: Teams.SEO,
                        feature: Features.GlobalNav,
                        component: Components.SearchBar,
                        name: 'search-bar',
                        action: Actions.Click,
                    })}
                >
                    <>
                        <Typography
                            variant="body-md"
                            as="span"
                            color="neutral-700"
                            className={styles.content}
                            onClick={handleClick}
                        >
                            <span
                                className={styles.searchLabelWrapper}
                                style={{ gridColumn: 1 }}
                            >
                                <MagnifyingGlassIcon size="small" />
                                <span className={styles.desktopLabel}>
                                    {searchBar?.desktopLabel}
                                </span>
                                <span className={styles.mobileLabel}>
                                    {searchBar?.mobileLabel}
                                </span>
                                <span className={styles.mobileLocation}>
                                    {isUsingUserLocation
                                        ? currentLocationString
                                        : `in ${location?.currentPlace}`}
                                </span>
                            </span>
                            <span
                                className={styles.searchPageComponentWrapper}
                                style={{ gridColumn: 2 }}
                            >
                                <Divider direction="vertical" color="ui-500" />
                            </span>
                            <span
                                className={styles.searchPageComponentWrapper}
                                style={{ gridColumn: 3 }}
                            >
                                <div className={styles.locationWrapper}>
                                    <span>
                                        <span className={styles.locationLabel}>
                                            <MapPinIcon size="small" />
                                            {isUsingUserLocation
                                                ? currentLocationString
                                                : location?.currentPlace}
                                        </span>
                                    </span>
                                </div>
                            </span>
                        </Typography>

                        {showSearch ? (
                            <LazySearchTakeover data-testid="search-takeover">
                                {({
                                    SearchTakeover,
                                }: {
                                    SearchTakeover: any;
                                }) => (
                                    <SearchTakeover
                                        domNodeId="root"
                                        onClose={handleClose}
                                        id="search-takeover"
                                        isVisible={showSearch}
                                    />
                                )}
                            </LazySearchTakeover>
                        ) : null}
                    </>
                </div>
            ) : undefined}
        </div>
    );
};

const ResultsPageSearchBar = () => {
    return (
        <div>
            <LocationProvider>
                <ResultsPageSearchBarContent />
            </LocationProvider>
        </div>
    );
};

export default ResultsPageSearchBar;
